import { useMemo } from 'react'
import { ColumnDef } from '@tanstack/react-table'
import SimpleTable from 'app/components/table/SimpleTable'
import type { ActivityRow } from './useUserActivity'

export type UserActivityComponentProps = {
  activities: ActivityRow[]
}

export function UserActivityComponent({ activities }: UserActivityComponentProps) {
  const columns = useMemo(
    (): ColumnDef<ActivityRow, any>[] => [
      {
        id: `action`,
        accessorKey: `action`,
        header: `Action`,
        meta: { defaultVisible: true },
      },
      {
        id: `dateTime`,
        accessorKey: `dateTime`,
        header: `Date/Time`,
        meta: { defaultVisible: true },
      },
      {
        id: `email`,
        accessorKey: `email`,
        header: `Email`,
        meta: { defaultVisible: true },
      },
      {
        id: `role`,
        accessorKey: `role`,
        header: `Role`,
        meta: { defaultVisible: true },
      },
    ],
    [],
  )

  return (
    <div className="my-6">
      <h2 className="text-3xl font-semibold tracking-tight sm:truncate">Activity Logs</h2>
      <div className="mt-8">
        <SimpleTable columns={columns} data={activities} hideFooter noDataMessage="No activity logs found" />
      </div>
    </div>
  )
}
